export default __webpack_public_path__ + "static/media/loaderimage.864fdd6e.svg";